var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.75C10.8914 6.75 6.75 10.8914 6.75 16C6.75 21.1086 10.8914 25.25 16 25.25C21.1086 25.25 25.25 21.1086 25.25 16C25.25 10.8914 21.1086 6.75 16 6.75ZM5.25 16C5.25 10.0629 10.0629 5.25 16 5.25C21.9371 5.25 26.75 10.0629 26.75 16C26.75 21.9371 21.9371 26.75 16 26.75C10.0629 26.75 5.25 21.9371 5.25 16ZM15.25 10H16.75V15.25H21V16.75H15.25V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.bfa9a3fa3384cb372028c5d63e856830.svg";
export { ForwardRef as ReactComponent };